// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetGetAllCurrencies (params?: {}): Promise<Dict>;
    publicPostBuildRegisterSessionKeyTx (params?: {}): Promise<Dict>;
    publicPostRegisterSessionKey (params?: {}): Promise<Dict>;
    publicPostDeregisterSessionKey (params?: {}): Promise<Dict>;
    publicPostLogin (params?: {}): Promise<Dict>;
    publicPostStatistics (params?: {}): Promise<Dict>;
    publicPostGetAllCurrencies (params?: {}): Promise<Dict>;
    publicPostGetCurrency (params?: {}): Promise<Dict>;
    publicPostGetInstrument (params?: {}): Promise<Dict>;
    publicPostGetAllInstruments (params?: {}): Promise<Dict>;
    publicPostGetInstruments (params?: {}): Promise<Dict>;
    publicPostGetTicker (params?: {}): Promise<Dict>;
    publicPostGetLatestSignedFeeds (params?: {}): Promise<Dict>;
    publicPostGetOptionSettlementPrices (params?: {}): Promise<Dict>;
    publicPostGetSpotFeedHistory (params?: {}): Promise<Dict>;
    publicPostGetSpotFeedHistoryCandles (params?: {}): Promise<Dict>;
    publicPostGetFundingRateHistory (params?: {}): Promise<Dict>;
    publicPostGetTradeHistory (params?: {}): Promise<Dict>;
    publicPostGetOptionSettlementHistory (params?: {}): Promise<Dict>;
    publicPostGetLiquidationHistory (params?: {}): Promise<Dict>;
    publicPostGetInterestRateHistory (params?: {}): Promise<Dict>;
    publicPostGetTransaction (params?: {}): Promise<Dict>;
    publicPostGetMargin (params?: {}): Promise<Dict>;
    publicPostMarginWatch (params?: {}): Promise<Dict>;
    publicPostValidateInviteCode (params?: {}): Promise<Dict>;
    publicPostGetPoints (params?: {}): Promise<Dict>;
    publicPostGetAllPoints (params?: {}): Promise<Dict>;
    publicPostGetPointsLeaderboard (params?: {}): Promise<Dict>;
    publicPostGetDescendantTree (params?: {}): Promise<Dict>;
    publicPostGetTreeRoots (params?: {}): Promise<Dict>;
    publicPostGetSwellPercentPoints (params?: {}): Promise<Dict>;
    publicPostGetVaultAssets (params?: {}): Promise<Dict>;
    publicPostGetEtherfiEffectiveBalances (params?: {}): Promise<Dict>;
    publicPostGetKelpEffectiveBalances (params?: {}): Promise<Dict>;
    publicPostGetBridgeBalances (params?: {}): Promise<Dict>;
    publicPostGetEthenaParticipants (params?: {}): Promise<Dict>;
    publicPostGetVaultShare (params?: {}): Promise<Dict>;
    publicPostGetVaultStatistics (params?: {}): Promise<Dict>;
    publicPostGetVaultBalances (params?: {}): Promise<Dict>;
    publicPostEstimateIntegratorPoints (params?: {}): Promise<Dict>;
    publicPostCreateSubaccountDebug (params?: {}): Promise<Dict>;
    publicPostDepositDebug (params?: {}): Promise<Dict>;
    publicPostWithdrawDebug (params?: {}): Promise<Dict>;
    publicPostSendQuoteDebug (params?: {}): Promise<Dict>;
    publicPostExecuteQuoteDebug (params?: {}): Promise<Dict>;
    publicPostGetInviteCode (params?: {}): Promise<Dict>;
    publicPostRegisterInvite (params?: {}): Promise<Dict>;
    publicPostGetTime (params?: {}): Promise<Dict>;
    publicPostGetLiveIncidents (params?: {}): Promise<Dict>;
    publicPostGetMakerPrograms (params?: {}): Promise<Dict>;
    publicPostGetMakerProgramScores (params?: {}): Promise<Dict>;
    privatePostGetAccount (params?: {}): Promise<Dict>;
    privatePostCreateSubaccount (params?: {}): Promise<Dict>;
    privatePostGetSubaccount (params?: {}): Promise<Dict>;
    privatePostGetSubaccounts (params?: {}): Promise<Dict>;
    privatePostGetAllPortfolios (params?: {}): Promise<Dict>;
    privatePostChangeSubaccountLabel (params?: {}): Promise<Dict>;
    privatePostGetNotificationsv (params?: {}): Promise<Dict>;
    privatePostUpdateNotifications (params?: {}): Promise<Dict>;
    privatePostDeposit (params?: {}): Promise<Dict>;
    privatePostWithdraw (params?: {}): Promise<Dict>;
    privatePostTransferErc20 (params?: {}): Promise<Dict>;
    privatePostTransferPosition (params?: {}): Promise<Dict>;
    privatePostTransferPositions (params?: {}): Promise<Dict>;
    privatePostOrder (params?: {}): Promise<Dict>;
    privatePostReplace (params?: {}): Promise<Dict>;
    privatePostOrderDebug (params?: {}): Promise<Dict>;
    privatePostGetOrder (params?: {}): Promise<Dict>;
    privatePostGetOrders (params?: {}): Promise<Dict>;
    privatePostGetOpenOrders (params?: {}): Promise<Dict>;
    privatePostCancel (params?: {}): Promise<Dict>;
    privatePostCancelByLabel (params?: {}): Promise<Dict>;
    privatePostCancelByNonce (params?: {}): Promise<Dict>;
    privatePostCancelByInstrument (params?: {}): Promise<Dict>;
    privatePostCancelAll (params?: {}): Promise<Dict>;
    privatePostCancelTriggerOrder (params?: {}): Promise<Dict>;
    privatePostGetOrderHistory (params?: {}): Promise<Dict>;
    privatePostGetTradeHistory (params?: {}): Promise<Dict>;
    privatePostGetDepositHistory (params?: {}): Promise<Dict>;
    privatePostGetWithdrawalHistory (params?: {}): Promise<Dict>;
    privatePostSendRfq (params?: {}): Promise<Dict>;
    privatePostCancelRfq (params?: {}): Promise<Dict>;
    privatePostCancelBatchRfqs (params?: {}): Promise<Dict>;
    privatePostGetRfqs (params?: {}): Promise<Dict>;
    privatePostPollRfqs (params?: {}): Promise<Dict>;
    privatePostSendQuote (params?: {}): Promise<Dict>;
    privatePostCancelQuote (params?: {}): Promise<Dict>;
    privatePostCancelBatchQuotes (params?: {}): Promise<Dict>;
    privatePostGetQuotes (params?: {}): Promise<Dict>;
    privatePostPollQuotes (params?: {}): Promise<Dict>;
    privatePostExecuteQuote (params?: {}): Promise<Dict>;
    privatePostRfqGetBestQuote (params?: {}): Promise<Dict>;
    privatePostGetMargin (params?: {}): Promise<Dict>;
    privatePostGetCollaterals (params?: {}): Promise<Dict>;
    privatePostGetPositions (params?: {}): Promise<Dict>;
    privatePostGetOptionSettlementHistory (params?: {}): Promise<Dict>;
    privatePostGetSubaccountValueHistory (params?: {}): Promise<Dict>;
    privatePostExpiredAndCancelledHistory (params?: {}): Promise<Dict>;
    privatePostGetFundingHistory (params?: {}): Promise<Dict>;
    privatePostGetInterestHistory (params?: {}): Promise<Dict>;
    privatePostGetErc20TransferHistory (params?: {}): Promise<Dict>;
    privatePostGetLiquidationHistory (params?: {}): Promise<Dict>;
    privatePostLiquidate (params?: {}): Promise<Dict>;
    privatePostGetLiquidatorHistory (params?: {}): Promise<Dict>;
    privatePostSessionKeys (params?: {}): Promise<Dict>;
    privatePostEditSessionKey (params?: {}): Promise<Dict>;
    privatePostRegisterScopedSessionKey (params?: {}): Promise<Dict>;
    privatePostGetMmpConfig (params?: {}): Promise<Dict>;
    privatePostSetMmpConfig (params?: {}): Promise<Dict>;
    privatePostResetMmp (params?: {}): Promise<Dict>;
    privatePostSetCancelOnDisconnect (params?: {}): Promise<Dict>;
    privatePostGetInviteCode (params?: {}): Promise<Dict>;
    privatePostRegisterInvite (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
